module.exports = __webpack_public_path__ + "img/2.a9cc41f5.png";